'use client';

import React from 'react';
import Link from 'next/link';
import { Box, Typography } from '@mui/material';

interface LogoProps {
  collapsed?: boolean;
  variant?: 'light' | 'dark';
}

/**
 * Logo Component
 * Displays the AssetCAST logo with version
 * Clicking the logo navigates to the home page
 */
export function Logo({ collapsed = false, variant }: LogoProps) {
  return (
    <Link href="/" style={{ textDecoration: 'none', width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          gap: 1,
          padding: 0,
          paddingLeft: collapsed ? 0 : '0.5rem',
          width: '100%',
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.8,
          },
          transition: 'opacity 0.2s',
        }}
      >
        {collapsed ? (
          // Collapsed logo - AssetCAST icon centered
          <Box
            sx={{
              width: 24,
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              component="img"
              src="/assetcast/assetcast-icon.svg"
              alt="assetCAST"
              sx={{
                width: 24,
                height: 24,
                objectFit: 'contain',
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Box
              component="img"
              src="/assetcast/assetcast-icon.svg"
              alt="assetCAST"
              sx={{
                width: 24,
                height: 24,
                flexShrink: 0,
              }}
            />
            <Box>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  color: variant === 'dark' ? 'common.white' : 'text.primary',
                  lineHeight: 1,
                }}
              >
                assetCAST
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Link>
  );
}
